<template>
    <div
        class="search_component"
        :class="activeSearch ? 'searching' : 'not-searching'"
        @keyup.esc="resetSearch"
        v-on-clickaway="resetSearch">

       <div class="col search-input">
            <div 
                @click="setActiveSearch()"
                v-if="!activeSearch"
                class="search-placeholder rounded-circle avatar-md text-center text-gray-500">
                <i class="fas fa-search"></i>
            </div>

            <input type="text" 
            ref="search"
                :value='search_query'
                @input='evt=>search_query=evt.target.value'
            class="form-control"
            @keyup="ExecuteSearch" 
            @focus="setActiveSearch()"
            :placeholder="activeSearch ? 'Search' : ''">
        </div>
        <div class="col">
            <ul v-show="results.length > 0" class="search_results list-group list-group-flush rounded-bottom bg-white mt-1 pl-0 border">
                <li class="single_search_result list-group-item text-left leading-tight" v-for="result in results" @click="resetSearch()">
                    <router-link :to="{ name: 'physicians.show', params: { id: result.id } }"> 
    	                <span class="font-weight-bold">{{ result.display_name }} </span><br>
                        <span class="badge bg-teal-100 text-teal-700 mr-1" v-for="specialty in result.specialties">{{ specialty.label }}</span>
    	                <span v-if="result.location_primary" class="text-gray-500 text-sm mt-1">
                            <br>{{ result.location_primary.short_address }}
                        </span>
                    </router-link>  
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mixin as clickaway } from 'vue-clickaway';

    export default {    
        mixins: [ clickaway ],

        data() {
            return {
                search_query: '',
                results: '',
                showResults: false,
                activeSearch: false,
            }
        },
        created() {
            this.ExecuteSearch = debounce(this.ExecuteSearch, 300);
        },

        methods: {
            setActiveSearch() {
                this.activeSearch = true;
                this.$refs.search.focus();
            },

            ExecuteSearch() {
                axios.get('/api/execute_search?search_query=' +this.search_query ).then(({ data }) => {
			       this.results = data.results;
			    });
            },

            resetSearch() {
                this.results = '';
                this.search_query = '';
                this.showResults = false;
                this.activeSearch = false;
            }
        },


    }
</script>

<style>
    /* Search styling in resources/assests/sass/components/_search.scss */
</style>